const WA_NUMBER = "447723547655"; // international format, no leading 00 or +
const PREFILL =
  "Hi BrandWithAbdo, I'd like to learn more about your services.";

export default function WhatsAppFAB() {
  const href = `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(PREFILL)}`;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-fab"
      aria-label="Chat on WhatsApp"
      className="group fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-[60] flex items-center gap-2 pl-1 pr-1 py-1 rounded-full bg-[#25D366] text-white shadow-[0_10px_40px_rgba(37,211,102,0.45)] hover:bg-[#1ebe5d] transition-all duration-300"
    >
      <span className="grid place-items-center h-12 w-12 rounded-full bg-white/15 backdrop-blur-sm">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="h-6 w-6 fill-white"
          aria-hidden="true"
        >
          <path d="M19.11 17.39c-.27-.13-1.59-.78-1.84-.87-.25-.09-.43-.13-.61.14-.18.27-.7.86-.86 1.04-.16.18-.32.2-.59.07-.27-.13-1.13-.42-2.15-1.33-.79-.7-1.33-1.57-1.49-1.84-.16-.27-.02-.41.12-.55.12-.12.27-.32.41-.48.13-.16.18-.27.27-.45.09-.18.05-.34-.02-.48-.07-.13-.61-1.47-.84-2.01-.22-.53-.45-.46-.61-.47-.16-.01-.34-.01-.52-.01s-.48.07-.73.34c-.25.27-.95.93-.95 2.27 0 1.34.97 2.64 1.11 2.82.14.18 1.92 2.93 4.65 4.11.65.28 1.16.45 1.55.58.65.21 1.24.18 1.71.11.52-.08 1.59-.65 1.81-1.28.23-.63.23-1.17.16-1.28-.06-.11-.24-.18-.51-.31zM16.02 5.33c-5.89 0-10.67 4.78-10.67 10.67 0 1.88.49 3.72 1.42 5.34L5 27.33l6.13-1.61c1.56.85 3.32 1.3 5.12 1.3h.01c5.89 0 10.67-4.78 10.67-10.67 0-2.85-1.11-5.53-3.12-7.54-2.02-2.01-4.7-3.12-7.55-3.12zm0 19.51h-.01c-1.6 0-3.16-.43-4.53-1.24l-.32-.19-3.36.88.9-3.27-.21-.34c-.9-1.42-1.37-3.07-1.37-4.74 0-4.93 4.01-8.94 8.95-8.94 2.39 0 4.63.93 6.32 2.62 1.69 1.69 2.62 3.94 2.62 6.33-.01 4.93-4.02 8.94-8.96 8.94z" />
        </svg>
      </span>
      <span className="pr-4 pl-1 text-sm font-semibold hidden sm:inline">
        Chat on WhatsApp
      </span>
    </a>
  );
}
